import { type Err } from '../CreateActivityTagModal/types'

import { useMutation } from '@percent/partner-dashboard/common/hooks/useMutation/useMutation'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type UseEditActivityTagProps = Readonly<{
  onEdited: () => void
  onError: (error: Err) => void
}>

export type UseEditActivityTagReturn = Readonly<{
  isLoading: boolean
  editActivityTag: (id: string, name: string) => void
}>

const defaultError: Err = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useEditActivityTag = ({ onEdited, onError }: UseEditActivityTagProps): UseEditActivityTagReturn => {
  const { workplaceGivingService } = useServices()

  const [{ isLoading }, { apiFunc: editVolunteeringActivity }] = useMutation(
    workplaceGivingService.editVolunteeringActivity,
    () => {
      onEdited()
    },
    error => {
      onError(error?.response?.data?.error ?? defaultError)
    }
  )

  return {
    isLoading,
    editActivityTag: (id: string, name: string) => {
      editVolunteeringActivity({ id, name })
    }
  }
}
